
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M256 42.5V64h64v98c0 107.3.3 101.9-5.8 108.3-1.5 1.6-4.4 3.8-6.5 4.8-3.5 1.9-5.7 2-31.6 1.7l-27.8-.3-3.9-2.7c-2.1-1.5-5-4.4-6.4-6.5l-2.5-3.7-.5-92.1-.5-92.2-3-4.8c-2.2-3.6-4.5-5.7-8.4-7.7l-5.3-2.8h-78.9c-86.3 0-82.9-.2-89.2 5.8-1.6 1.5-3.7 4.4-4.8 6.4-1.9 3.7-1.9 7.5-1.7 150.5l.3 146.8 3.1 6.5c3.5 7.5 8 12.9 14.3 17.5 3.9 2.8 4.6 4.1 7.1 11.8 7.3 22.8 22.1 40.1 43.2 50.7 14.1 7.1 25.2 9.4 41.6 8.7 23.5-1 41.4-8.9 57.3-25.4 9.7-10 16.3-20.7 20.3-33l1.8-5.3h90.4l1.8 5.8c6.4 20.7 23.5 40.1 44.1 49.8 12.3 5.8 19 7.4 33.1 8.1 26.3 1.2 47.6-7.5 66.1-27.1 9.3-9.7 16.9-23.7 20.4-37.1 2.9-11.1 3-29.9.1-40.5-1.1-4.1-15.5-44.5-32-89.8l-30-82.2H469V64H363V52.9c0-14-1.2-18.7-6.2-24.4-6.5-7.4-7.3-7.5-57.5-7.5H256zm-64 75V128H85v-21h107zM427 128v21h-64v-42h64zm-235 75v32l-53.2-.2-53.3-.3-.3-31.8L85 171h107zm189.4-9.5c.3.9 9 24.6 19.2 52.8 10.3 28.1 18.8 51.6 19.1 52.2.2.6-5 1-14.4 1-17.6 0-23.2 1.3-37.8 8.4-20.4 10.1-36.7 28.7-43.1 49.3l-1.8 5.8h-90.4l-1.8-5.3c-9.4-28.9-34.5-51.2-64.3-57.2-11.1-2.3-29.4-1.6-39.9 1.4-13.3 3.9-26.8 11.7-37 21.4l-4.2 4.2.2-25 .3-25 55-.2 55-.2 3.9 8.2c7.8 16.1 25 29.4 43.1 33.2 10.3 2.1 58.7 2.1 69.3-.1 18.9-3.8 35.2-16.4 44-34 6.2-12.3 6.5-14.3 6.9-55.2l.5-37.2h8.8c6.9 0 8.9.3 9.4 1.5M156.6 342.1c8.8 1.6 16.2 5.6 22.7 12 16.8 16.8 16.8 43 0 59.8-16.6 16.5-42 16.9-58.8 1-9.2-8.7-13.5-18.5-13.5-30.9 0-12.3 4.3-22.2 13.3-30.8 6.4-6 11.9-8.9 20.1-10.7 7.8-1.7 9-1.7 16.2-.4m256 0c8.8 1.6 16.2 5.6 22.7 12 16.8 16.8 16.8 43 0 59.8-16.5 16.4-42 16.9-58.8 1-9.2-8.7-13.5-18.5-13.5-31 0-7.3 2.7-17.5 6-22.4 6.3-9.6 18.4-17.7 28.6-19.4 7.1-1.2 8.4-1.2 15 0"}})])
          )
        }
      }
    